import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ptCommon from './locales/pt-BR/common.json';
import ptNav from './locales/pt-BR/nav.json';
import ptBoard from './locales/pt-BR/board.json';
import ptArticles from './locales/pt-BR/articles.json';
import ptFeedDrive from './locales/pt-BR/feeddrive.json';
import ptAnalytics from './locales/pt-BR/analytics.json';
import ptConfig from './locales/pt-BR/config.json';
import ptStrategist from './locales/pt-BR/strategist.json';
import ptFunil from './locales/pt-BR/funil.json';

import enCommon from './locales/en-US/common.json';
import enNav from './locales/en-US/nav.json';
import enBoard from './locales/en-US/board.json';
import enArticles from './locales/en-US/articles.json';
import enFeedDrive from './locales/en-US/feeddrive.json';
import enAnalytics from './locales/en-US/analytics.json';
import enConfig from './locales/en-US/config.json';
import enStrategist from './locales/en-US/strategist.json';
import enFunil from './locales/en-US/funil.json';

export const defaultNS = 'common';
export const resources = {
  'pt-BR': {
    common: ptCommon,
    nav: ptNav,
    board: ptBoard,
    articles: ptArticles,
    feeddrive: ptFeedDrive,
    analytics: ptAnalytics,
    config: ptConfig,
    strategist: ptStrategist,
    funil: ptFunil,
  },
  'en-US': {
    common: enCommon,
    nav: enNav,
    board: enBoard,
    articles: enArticles,
    feeddrive: enFeedDrive,
    analytics: enAnalytics,
    config: enConfig,
    strategist: enStrategist,
    funil: enFunil,
  },
} as const;

const savedLanguage =
  typeof window !== 'undefined' ? localStorage.getItem('wiredesk_locale') || 'pt-BR' : 'pt-BR';

void i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage,
  fallbackLng: 'pt-BR',
  defaultNS,
  ns: [
    'common',
    'nav',
    'board',
    'articles',
    'feeddrive',
    'analytics',
    'config',
    'strategist',
    'funil',
  ],
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
